import React, { Component } from 'react';
import './App.css';
import { Route, BrowserRouter as Router } from 'react-router-dom'
import Navbar from './components/reusables/navbar'

import Home from './components/home'
import Fruit from './components/fruit'
import Empresa from './components/empresa'
import Contact from './components/contact'
import Galeria from './components/vivir/index';

import RUHome from './components/ru-home'
import RUFruit from './components/ru-fruit'
import RUEmpresa from './components/ru-empresa'
import RUContact from './components/ru-contact'
import RUGaleria from './components/ru-vivir';

import ENHome from './components/en-home'
import ENFruit from './components/en-fruit'
import ENEmpresa from './components/en-empresa'
import ENContact from './components/en-contact'
import ENGaleria from './components/en-vivir';

class App extends Component {

  constructor(props){
    super(props)
    this.state = {
      lang: 'ES',
      l1: 'HOME',
      l2: 'EMPRESA',
      l3: 'PIORICOST FRUIT',
      l4: 'GALERÍA',
      l5: 'CONTÁCTANOS',
      r1: '/',
      r2: '/empresa',
      r3: '/pioricost-fruit',
      r4: '/galeria',
      r5: '/contacto'
    }
  }

  langToggle(lang){
    if(lang == "ES"){
      this.setState({
        lang: 'ES',
        l1: 'HOME',
        l2: 'EMPRESA',
        l3: 'PIORICOST FRUIT',
        l4: 'GALERÍA',
        l5: 'CONTÁCTANOS',
        r1: '/',
        r2: '/empresa',
        r3: '/pioricost-fruit',
        r4: '/galeria',
        r5: '/contacto'
      })
    } else if(lang == "RU"){
      this.setState({
        lang: 'RU',
        l1: 'Главная',
        l2: 'Компания ',
        l3: 'PIORICOST FRUIT',
        l4: 'Галерея ',
        l5: 'Контакты ',
        r1: '/ru',
        r2: '/ru/empresa',
        r3: '/ru/pioricost-fruit',
        r4: '/ru/galeria',
        r5: '/ru/contacto'
      })
    } else if(lang == "EN"){
      this.setState({
        lang: 'EN',
        l1: 'HOME',
        l2: 'COMPANY',
        l3: 'PIORICOST FRUIT',
        l4: 'GALLERY ',
        l5: 'CONTACT ',
        r1: '/en',
        r2: '/en/empresa',
        r3: '/en/pioricost-fruit',
        r4: '/en/galeria',
        r5: '/en/contacto'
      })
      
  }
}

  render() {
    return (
      <Router>
      <div className="App">
      <Navbar 
        link1={this.state.l1} 
        link2={this.state.l2} 
        link3={this.state.l3} 
        link4={this.state.l4} 
        link5={this.state.l5}
        red1={this.state.r1}
        red2={this.state.r2}
        red3={this.state.r3}
        red4={this.state.r4}
        red5={this.state.r5}
        buttonClick={this.langToggle.bind(this)}
        />

          <Route exact path="/" component={Home} />
          <Route exact path="/ru" component={RUHome} />
          <Route exact path="/en" component={ENHome} />

          <Route path="/empresa" component={Empresa} />
          <Route path="/pioricost-fruit" component={Fruit} />
          <Route path="/pioricost-fish" component={Home} />
          <Route path="/pioricost-roses" component={Home} />
          <Route path="/galeria" component={Galeria} />
          <Route path="/contacto" component={Contact} />

          <Route path="/ru/empresa" component={RUEmpresa} />
          <Route path="/ru/pioricost-fruit" component={RUFruit} />
          <Route path="/ru/pioricost-fish" component={RUHome} />
          <Route path="/ru/pioricost-roses" component={RUHome} />
          <Route path="/ru/galeria" component={RUGaleria} />
          <Route path="/ru/contacto" component={RUContact} />

          <Route path="/en/empresa" component={ENEmpresa} />
          <Route path="/en/pioricost-fruit" component={ENFruit} />
          <Route path="/en/pioricost-fish" component={ENHome} />
          <Route path="/en/pioricost-roses" component={ENHome} />
          <Route path="/en/galeria" component={ENGaleria} />
          <Route path="/en/contacto" component={ENContact} />
      </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js